module.exports = __webpack_public_path__ + "img/number02.a6e5629f.png";